import { render, staticRenderFns } from "./_totalMiniGameCoinUsed.vue?vue&type=template&id=52cfd40a&lang=pug"
import script from "./_totalMiniGameCoinUsed.vue?vue&type=script&lang=js"
export * from "./_totalMiniGameCoinUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports